<template>
    <div>
      <BaseIcon
        name="shopping-cart"
        width="25"
        height="25"
        class="my-1 mr-2"
        style="float: right"
      />
      <h3>{{ "Payment Failed!" | translate }}</h3>
      <div class="cart panel p-2">
        <div class="panel t1 p-2">
          <div class="text-center">
            <img src="/assets/img/error.png" style="width: 50px;" /> {{ $t("payment_error") }}
          </div>
          <div class="row mx-1 d-flex justify-content-between my-1">
            <div class="col-lg-12 m-0 text-center">
              <button
                class="btn btn-lg btn-danger m-0"
                @click="checkout()"
              >
                {{ "Wiederholen" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  export default {
    name: "app-paymentfail",
    components: {},
    data() {
      return {
        paymentStatus: "",
        paySuccess: false,
        spinner: false,
        tryAgain: false,
      };
    },
    computed: {
      ...mapGetters(["orderData", "total", "companyData"]),
      AllowHobex() {
        if (this.companyData.pspType == 2) {
          return true;
        } else {
          return false;
        }
      },
      AllowWalle() {
        if (this.companyData.pspType == 3) {
          return true;
        } else {
          return false;
        }
      },
      TableToken() {
        return this.companyData.tableOrderToken;
      },
      cSymb() {
        if (this.companyData.storeCurrency === "EUR") {
          return "€";
        } else if (this.companyData.storeCurrency === "USD") {
          return "$";
        } else {
          return this.companyData.storeCurrency;
        }
      },
      total() {
        return this.orderData.total;
      },
      paymentId() {
        if (this.AllowHobex) {
          return this.orderData.transactionReference;
        }else if (this.AllowWalle){
          return this.orderData.walleeTid;
        }else{
          return "000";
        }
      }
    },
    methods: {
      checkout() {
        this.$router.push({ path: "/checkout" });
      },
      goHome() {
        setTimeout(() => {
          this.$router.push({ path: "/" });
        }, 300);
      },
    },
    created() {},
    mounted() {
        if (window.top !== window.self) {
          window.top.location.replace('/payfail');
        }
    }
}
  </script>
  